import {
  ScaffolderFieldError,
  ScaffolderInputHeader,
} from '@internal/plugin-scaffolder-common-field-react';
import React, { useCallback } from 'react';

import { Box, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import * as doc from '../infoDoc';
import { useStyles } from '../styles';
import { Project } from '../types';

interface ProjectPickerProps {
  onChange: (value: string) => void;
  projects: Project[];
  formData: string;
  loading: boolean;
  rawErrors: string[];
  disabled?: boolean;
}

const ProjectPickerInner = (props: ProjectPickerProps) => {
  const { onChange, formData, projects, loading, rawErrors, disabled } = props;
  const classes = useStyles();

  const handleProjectSelect = useCallback(
    (_: any, value: Project | null) => {
      onChange(value?.name || '');
    },
    [onChange],
  );

  const selectedProject = projects?.find(e => e.name === formData) || null;

  return (
    <Box className={classes.inputContainer}>
      <ScaffolderInputHeader
        title="Project Details"
        description="Select the project you want to associate the application with."
        infoDoc={doc.PROJECT_INFO}
      />
      <Autocomplete
        size="small"
        value={selectedProject}
        loading={loading}
        onChange={handleProjectSelect}
        options={projects}
        disabled={disabled}
        getOptionLabel={option => option.title || option.name}
        renderInput={params => (
          <TextField
            {...params}
            label="Project Name"
            margin="none"
            variant="outlined"
            color="secondary"
            required
            InputProps={params.InputProps}
            error={Boolean(rawErrors?.length > 0) && !formData}
            helperText={
              Boolean(rawErrors?.length > 0) && !formData ? (
                <ScaffolderFieldError message="Project is required" />
              ) : undefined
            }
          />
        )}
        renderOption={option => (
          <Box>
            <Typography variant="body2" noWrap>
              {option.title}
            </Typography>
            {option.name && (
              <Typography variant="caption" noWrap color="textSecondary">
                {option.name}
              </Typography>
            )}
          </Box>
        )}
        noOptionsText="No projects found"
        loadingText="Loading projects..."
      />
    </Box>
  );
};

export const ProjectPicker = React.memo(ProjectPickerInner);
